import { ComponentType } from 'react'

import dynamic from 'next/dynamic'

import { miToKm } from '@lib/helpers/client'

import { ItemType } from '../dropdown'
import { DropDownProps } from '../dropdown/dropdown'

const DropDown = dynamic(() => import('@components/inputs/dropdown')) as ComponentType<DropDownProps<number>>

type DistanceFilterProps = {
  onChange: (value: ItemType<number>) => Promise<void> | void
  value: number
  dropdownProps?: Partial<DropDownProps<number>>
}

const DistanceFilter = ({ onChange, value, dropdownProps }: DistanceFilterProps): JSX.Element => {
  // values in miles
  const distanceOptions: ItemType<number>[] = [
    { value: miToKm(5), label: 'Within 5 miles' },
    { value: miToKm(10), label: 'Within 10 miles' },
    { value: miToKm(25), label: 'Within 25 miles' },
    { value: miToKm(40), label: 'Within 40 miles' },
    { value: miToKm(60), label: 'Within 60 miles' },
    { value: miToKm(100), label: 'Within 100 miles' },
  ]

  return (
    <DropDown
      ariaLabelledBy="search-radius"
      menuPlacement="bottom"
      options={distanceOptions}
      initialValue={distanceOptions.find((x) => x.value === value) || distanceOptions[2]}
      onChange={onChange}
      id="maxRadius"
      {...dropdownProps}
    />
  )
}

export default DistanceFilter
